// extracted by mini-css-extract-plugin
export default {"root":"root__8H9WZ","fadeInAnimation":"fadeInAnimation__y7Oy8","termCheckInput":"termCheckInput__WkEFs","termCheckButton":"termCheckButton__GmWwH"};